export default {
  common: {
    comingSoon: 'Coming soon',
    view: 'View',
    show: 'Show on profile',
    hide: 'Hide on profile',
    optional: 'Optional',
    confirmDeleteYes: 'yes',
    confirmDeleteNo: 'no',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    deleteCard: 'Delete this card',
    cancel: 'Cancel',
    confirm: 'Confirm',
    loading: 'loading',
    addSuccess: 'Add success',
    editSuccess: 'Edit success',
    deleteSuccess: 'Delete success',
    imageCropTip: 'Please cover the entire cropping area with image.',
    editPhotoTip: 'Please adjust your photo position and size by zooming in and out. Then, click "save" to confirm.',
    back: 'Back',
    close: 'Close',
    generateShortUrlTip: 'Failed to generate short link, please try again later',
    generateShareUrlTip: 'Failed to generate share link, please try again later',
    generateQRCodeTip: 'Failed to generate QR code, please try again later',
    search: 'Search',
    serialNumber: 'No.',
    hint: 'hint',
    add: 'Add',
    custom: 'Custom',
    send: 'Send',
    fillRequired: 'Please fill in the required fields',
    exchangeSuccess: 'Exchange success',
    exchangeFailed: 'Failed to exchange, please try again later',
    // Image cropper related
    cropImage: 'Crop Image',
    imageToBeCropped: 'Image to be cropped',
    cropperNotInitialized: 'Cropper not initialized',
    cropFailed: 'Crop failed',
    convertImageFailed: 'Failed to convert image',
    displayText: 'Display Text',
    linkCopied: 'Link copied to clipboard',
    linkCopiedError: 'Failed to copy link, please try again later',
    linkCopiedErrorTip: 'Please try again later to copy link',
  },
  navFooterTabber: {
    myECard: 'Card',
    home: 'Home',
    create: 'Create',
    my: 'My Account',
    createTitle: 'Create business card',
    cardDetail: 'Business card detail',
    cardPreview: 'Business card preview',
    login: 'Login',
    templateManagement: 'Template Management',
    maxCardNum: 'Maximum 3 business cards allowed',
    companyManagement: 'Company Mgmt',
    employeeManagement: 'Employee Mgmt',
    companyInfo: 'Company Info',
    systemManagement: 'System Mgmt',
    userManagement: 'User Mgmt',
    customerManagement: 'CRM',
    platformCompany: 'Enterprise Customers',
  },
  home: {
    myCardHolder: 'My Business Card',
    homeDesc: 'Manage your professional profile.',
    total: 'A total of',
    businessCards: 'business cards created',
    startCreate: 'Make a lasting impression',
    startCreateDesc: 'Share your most up to date details and portfolio quickly and efficiently. Turn first meetings into lasting connections.',
    createCardButton: 'Create my first business card',
  },
  createCard: {
    createTitle: 'Create business card',
    editTitle: 'Edit business card',
    templateType: 'Template Type',
    selectTemplate: 'Select template',
    Classic: 'Classic',
    Ribbol: 'Ribbon',
    BigHead: 'Full Frame',
    Landscape: 'Banner',
    themeColor: 'Theme Color',
    livePreview: 'Live Preview',
    create: 'Create a New Card',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    confirmDelete: 'Are you sure you want to delete this card?',
    confirmDeleteYes: 'Yes',
    confirmDeleteNo: 'No',
    display: 'Display',
    color: 'Color',
    black: 'Black',
    white: 'White',
    gray: 'Gray',
    green: 'Green',
    blue: 'Blue',
    cardBackground: 'Physical card background',
    physicalCardPreview: 'Physical card preview',
    uploadPhysicalCard: 'Upload physical card background',
    uploadPhysicalCardBack: 'Upload physical card background back',
    front: 'Front',
    back: 'Back',
    basicInfo: 'Basic Information',
    links: 'Links',
    prefix: 'Prefix',
    name: 'Name',
    suffix: 'Suffix',
    yourName: 'Your Name',
    jobTitle: 'Position',
    yourPosition: 'Your Position',
    company: 'Company',
    yourCompany: 'Your Company',
    contactInfo: 'Contact Information',
    email: 'Email',
    yourEmail: 'Your Email',
    selectLinkType: 'Select Link Type',
    addLink: 'Add Link',
    linkName: 'Link Name',
    linkNamePlaceholder: 'Please enter link name',
    linkAddress: 'Link Address',
    linkAddressPlaceholder: 'Please enter link address',
    selectIcon: 'Select Icon',
    mobile: 'Mobile',
    addMobile: 'Add Mobile',
    direct: 'Direct',
    addDirect: 'Add Direct',
    phone: 'Phone',
    addPhone: 'Add Phone',
    yourPhone: 'Your Phone',
    landline: 'Landline',
    addLandline: 'Add Landline',
    yourLandline: 'Your Landline',
    website: 'Website',
    address: 'Address',
    yourAddress: 'Your Address',
    country: 'Country',
    city: 'City',
    postcode: 'Postcode',
    socialMedia: 'Social Media',
    pleaseEnterFullLinks: 'Please enter the full links.',
    productIntroduction: 'Product Introduction',
    wechat: 'WeChat',
    wechatId: 'Wechat ID',
    facebook: 'Facebook',
    twitter: 'Twitter (X)',
    linkedin: 'LinkedIn',
    instagram: 'Instagram',
    pinterest: 'Pinterest',
    youtube: 'YouTube',
    other: 'Other',
    channelName: 'Channel Name',
    newChannel: 'New Channel',
    profileLink: 'Profile Link',
    displayText: 'Display Text',
    pictureInformation: 'Picture Information',
    companyLogo: 'Company Logo',
    companyLogoDesc: 'Upload your company logo',
    IDPhoto: 'Profile Photo',
    IDPhotoDesc: 'Upload your profile photo',
    nameRequired: 'Please enter your name',
    jobTitleRequired: 'Please fill in the title',
    companyRequired: 'Please fill in the company name',
    emailRequired: 'Please enter your email',
    emailFormatError: 'Please enter the correct email format',
    phoneRequired: 'Please provide your phone number',
    addressRequired: 'Please fill in the address',
    companyLogoRequired: 'Please upload the company logo',
    IDPhotoUploadSuccess: 'Personal photo uploaded successfully',
    companyLogoUploading: 'Uploading...',
    companyLogoUploadMaxSize: 'Please upload an image less than 30MB',
    companyLogoUploadSuccess: 'Upload successful',
    companyLogoUploadFormat: 'Please upload jpg/png format images',
    companyLogoUploadTip: '*Recommend to use a png file with transparent background.',
    reUpload: 'Re-upload',
    uploadImage: 'Upload Image',
    uploadImageDesc: 'To ensure optimal card quality, please upload high-resolution JPG or PNG images (minimum 1712 × 1080 pixels).',
    physicalCardInfo: 'Physical Card Info',
    physicalCardInfoDesc: 'Customize your physical business card appearance',
    expand: 'Expand',
    collapse: 'Collapse',
    selectLayout: 'Select Layout',
    layoutDesc: 'Select your physical business card layout',
    backgroundCategory: 'Background Category',
    selectBackground: 'Select Background',
    textColor: 'Text Color',
    plainColours: 'Plain Colours',
    gradients: 'Gradients',
    gradientStrips: 'Gradient Strips',
    geometricBackground: 'Geometric Background',
    bottomLine: 'Bottom Line',
    waves: 'Waves',
    geometricLines: 'Geometric Lines',
    // white: 'White',
    // black: 'Black',
    // gray: 'Gray',
    darkGray: 'Dark Gray',
    navy: 'Navy',
    darkGreen: 'Dark Green',
    darkRed: 'Dark Red',
    gold: 'Gold',
    bluePurple: 'Blue Purple',
    pinkRed: 'Pink Red',
    blueCyan: 'Blue Cyan',
    goldOrange: 'Gold Orange',
    ocean: 'Ocean',
    sunset: 'Sunset',
    forest: 'Forest',
    rainbow: 'Rainbow',
    blueRed: 'Blue Red',
    lightGray: 'Light Gray',
    whiteDots: 'White Dots',
    darkDots: 'Dark Dots',
    whiteGrid: 'White Grid',
    darkGrid: 'Dark Grid',
    goldLine: 'Gold Line',
    blueLine: 'Blue Line',
    redLine: 'Red Line',
    darkGold: 'Dark Gold',
    blueWave: 'Blue Wave',
    greenWave: 'Green Wave',
    orangeWave: 'Orange Wave',
    whiteLines: 'White Lines',
    darkLines: 'Dark Lines',
    goldLines: 'Gold Lines',
    blueLines: 'Blue Lines',
    // Product Introduction Card
    simple: 'Simple',
    socialMediaTitle: 'Social Media',
    productCatalog: 'Product Catalog',
    show: 'Show',
    hide: 'Hide',
    image: 'Image',
    icon: 'Icon',
    productIntroductionName: 'Name',
    url: 'Url',
    description: 'Description',
    pleaseEnterDescription: 'Please enter description',
    pleaseEnterName: 'Please enter name',
    pleaseEnterAddress: 'Please enter address',
    selectIconFromProvided: 'Select icon from provided:',
    uploadFile: 'Upload File',
    addCustomInfo: 'Add Custom Info',
    customInfo: 'Custom Info',
    learnMore: 'Learn More',
    // Social media platform names
    prdYoutube: 'YouTube',
    prdFacebook: 'Facebook',
    prdInstagram: 'Instagram',
    prdLinkedIn: 'LinkedIn',
    prdWeibo: 'Weibo',
    prdXiaohongshu: 'Xiaohongshu',
    // Error messages
    imageFormatError: 'Only PNG and JPG images are supported',
    imageSizeError: 'Image size cannot exceed {size}MB',
    fileFormatError: 'Only PDF, Word, Excel, PPT files are supported',
    fileSizeError: 'File size cannot exceed 20MB',
    fileUploadError: 'File upload failed, please retry',
    imageUploadError: 'Image upload failed, please retry',
    uploadSuccess: 'Upload successful',
    // Alt attribute translations
    avatarPreview: 'Avatar Preview',
    imagePreview: 'Image Preview',
    iconPreview: 'Icon Preview',
    requiredLink: 'Required Link, Please fill in',
  },
  /** Link category names */
  linkCategories: {
    popular: 'Most Popular',
    social: 'Social',
    messaging: 'Messaging',
    meeting: 'Meeting',
    payment: 'Payment',
    video: 'Video',
    music: 'Music',
    design: 'Design',
    gaming: 'Gaming',
    other: 'Other',
  },
  /** Link label names */
  linkLabels: {
    phone: 'Phone',
    address: 'Address',
    directCall: 'Direct Dial',
    telephone: 'Telephone',
    website: 'Website',
    link: 'Link',
    instagram: 'Instagram',
    linkedin: 'LinkedIn',
    facebook: 'Facebook',
    xcom: 'X.com',
    snapchat: 'Snapchat',
    tiktok: 'TikTok',
    youtube: 'YouTube',
    pinterest: 'Pinterest',
    twitch: 'Twitch',
    xing: 'Xing',
    threads: 'Threads',
    weibo: 'Weibo',
    qq: 'QQ',
    whatsapp: 'WhatsApp',
    telegram: 'Telegram',
    discord: 'Discord',
    wechat: 'WeChat',
    line: 'Line',
    signal: 'Signal',
    fax: 'Fax',
    zoom: 'Zoom',
    teams: 'Teams',
    meet: 'Meet',
    skype: 'Skype',
    webex: 'Webex',
    venmo: 'Venmo',
    paypal: 'PayPal',
    cashapp: 'CashApp',
    zelle: 'Zelle',
    brightcove: 'Brightcove',
    vimeo: 'Vimeo',
    spotify: 'Spotify',
    applemusic: 'Apple Music',
    soundcloud: 'SoundCloud',
    behance: 'Behance',
    dribbble: 'Dribbble',
    psn: 'PSN',
    xboxlive: 'Xbox Live',
    nintendo: 'Nintendo',
    github: 'GitHub',
    calendly: 'Calendly',
    patreon: 'Patreon',
    yelp: 'Yelp',
    microsoftbookings: 'Microsoft Bookings',
  },
  /** 链接输入框占位符 */
  linkPlaceholders: {
    phone: 'Enter phone number',
    address: 'Enter address',
    directCall: 'Enter direct dial number',
    telephone: 'Enter landline number',
    website: 'Enter website URL',
    link: 'Enter link',
    instagram: 'Enter Instagram URL',
    linkedin: 'Enter LinkedIn URL',
    facebook: 'Enter Facebook URL',
    xcom: 'Enter X.com URL',
    snapchat: 'Enter Snapchat URL',
    tiktok: 'Enter Tiktok URL',
    youtube: 'Enter Youtube URL',
    pinterest: 'Enter Pinterest URL',
    twitch: 'Enter Twitch URL',
    xing: 'Enter Xing URL',
    threads: 'Enter Threads URL',
    weibo: 'Enter Weibo URL',
    qq: 'Enter QQ number',
    whatsapp: 'Enter WhatsApp URL',
    telegram: 'Enter Telegram URL',
    discord: 'Enter Discord URL',
    wechat: 'Enter WeChat ID',
    line: 'Enter Line URL',
    signal: 'Enter Signal URL',
    fax: 'Enter fax number',
    zoom: 'Enter Zoom URL',
    teams: 'Enter Teams URL',
    meet: 'Enter Meet URL',
    skype: 'Enter Skype URL',
    webex: 'Enter Webex URL',
    venmo: 'Enter Venmo URL',
    paypal: 'Enter PayPal URL',
    cashapp: 'Enter CashApp URL',
    zelle: 'Enter Zelle URL',
    brightcove: 'Enter Brightcove URL',
    vimeo: 'Enter Vimeo URL',
    spotify: 'Enter Spotify URL',
    applemusic: 'Enter Apple Music URL',
    soundcloud: 'Enter SoundCloud URL',
    behance: 'Enter Behance URL',
    dribbble: 'Enter Dribbble URL',
    psn: 'Enter PSN URL',
    xboxlive: 'Enter Xbox Live URL',
    nintendo: 'Enter Nintendo URL',
    github: 'Enter GitHub URL',
    calendly: 'Enter Calendly URL',
    patreon: 'Enter Patreon URL',
    yelp: 'Enter Yelp URL',
    microsoftbookings: 'Enter Microsoft Bookings URL',
    required: 'Required',
  },
  cardDetail: {
    templatePreview: 'Template Preview',
    company: 'Company',
    address: 'Address',
    landline: 'Phone',
    mobile: 'Mobile',
    direct: 'Direct',
    email: 'Email',
    website: 'Website',
    socialMedia: 'Social Media',
    wechat: 'WeChat',
    facebook: 'Facebook',
    twitter: 'Twitter (X)',
    linkedin: 'LinkedIn',
    instagram: 'Instagram',
    pinterest: 'Pinterest',
    youtube: 'YouTube',
    confirmDelete: 'Are you sure you want to delete?',
    confirmDeleteDesc: 'This operation will permanently delete this card, please operate with caution.',
    editCard: 'Edit Card',
    deleteCard: 'Delete Card',
    saveCard: 'Save as Image',
    shareLink: 'Share Link',
    copyLink: 'Copy Link',
    generatingCardImage: 'Generating business card image...',
    cardImageGenerated: 'Business card image generated',
    cardImageGeneratedError: 'Failed to generate business card image, please try again later',
    cardImageGeneratedSuccess: 'e-business card',
    shareCard: 'Share Card',
    saveToContacts: 'Save to Contacts',
    vCardGeneratedSuccess: 'vCard file generated successfully, please download and import into your contacts',
    vCardGeneratedError: 'Failed to generate vCard file, please try again',
    readingCard: 'Reading business card...',
    addByCardPage: 'Add by business card page',
    saveFailed: 'Save failed, please try again',
    linkCopied: 'Link copied to clipboard',
    linkCopiedError: 'Link copy failed, please manually copy the link',
    linkCopiedErrorTip: 'Please manually copy the link',
    previewCard: 'Preview Card',
    savePhysicalCard: 'Save Physical Business Card',
    viewPhysicalBusinessCards: 'View Physical Business Card',
    pushPhysicalBusinessCards: 'Push Physical Business Card',
    pushPhysicalBusinessCardsSuccess: 'Physical business card pushed successfully',
    pushPhysicalBusinessCardsError: 'Failed to push physical business card, please try again',
    pushPhysicalBusinessCardsErrorTip: 'Please check your network connection and try again',
    pushPhysicalBusinessCardsSuccessTip: 'Physical business card pushed successfully, please wait for confirmation',
    pushPhysicalBusinessCardsErrorTip2: 'Please check your network connection and try again',
    terminalScanningTwoDimensionalCodeBusinessCardPrinting: 'Terminal scanning two-dimensional code business card printing',
    saveContact: 'Save Contact',
    exchangeContact: 'Exchange Contact',
    shareYourContact: 'Share Contact to',
    firstName: 'First Name',
    lastName: 'Last Name',
    phoneNumber: 'Phone Number',
  },
  my: {
    logOut: 'Log out',
    language: 'Language',
    chinese: '简体中文',
    english: 'English',
    profile: 'Profile',
    changePassword: 'Change Password',
    quickActions: 'Quick Actions',
    oldPassword: 'Old Password',
    enterOldPassword: 'Please enter old password',
    newPassword: 'New Password',
    enterNewPassword: 'Please enter new password',
    enterConfirmPassword: 'Please enter confirm new password',
    confirmPasswordError: 'New password and confirm new password do not match',
    confirmPassword: 'Confirm New Password',
    newPasswordLengthError: 'New password must be at least 6 characters long',
    samePasswordError: 'New password cannot be the same as old password',
    changePasswordSuccess: 'Password changed successfully',
    changePasswordFailed: 'Password change failed, please try again',
    oldPasswordError: 'Old password is incorrect',
    logOutSuccess: 'Log out successful',
    logOutConfirm: 'Are you sure you want to log out?',
  },
  login: {
    welcome: 'Business card profile login',
    subtitle: 'Sign into your profile. Username and passwords are case sensitive.',
    subtitleTip: 'For new users, please enter your preferred email and a new password to register.',
    usernamePlaceholder: 'Enter username or email',
    passwordPlaceholder: 'Enter password',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    loginButton: 'Sign in / Sign up',
    login: 'Login',
    loggingIn: 'Signing in...',
    noAccount: 'Don\'t have an account?',
    register: 'Sign up',
    usernameRequired: 'Please enter username or email',
    passwordRequired: 'Please enter password',
    loginSuccess: 'Login successful',
    forgotPasswordTip: 'Forgot password feature coming soon',
    registerTip: 'Registration feature coming soon',
    passwordMinLength: 'Password must be at least 6 characters long',
    loginError: 'Incorrect username or password.',
    usernameMinLength: 'Username must be at least 5 characters long',
    brandSlogan: 'Digital Business Card · Smart Connection',
    loginErrorTip: 'Login failed multiple times, account locked for 15 minutes',
    usernameOrPasswordErrorTip: 'Username or password is incorrect',
    remainingAttempts: 'Remaining attempts: {remaining}',
    locked: 'Account locked, please try again in {remaining} seconds',
    signUp: 'Sign up',
  },
  register: {
    firstName: 'First Name',
    firstNamePlaceholder: 'Enter first name',
    firstNameRequired: 'Please enter first name',
    lastName: 'Last Name',
    lastNamePlaceholder: 'Enter last name',
    lastNameRequired: 'Please enter last name',
    email: 'Email',
    emailPlaceholder: 'Enter email',
    emailRequired: 'Please enter email',
    emailInvalid: 'Please enter a valid email address',
    username: 'Username',
    usernamePlaceholder: 'Enter username',
    usernameRequired: 'Please enter username',
    usernameInvalid: 'Username must be at least 3 characters and contain only letters, numbers, and underscores',
    password: 'Password',
    passwordPlaceholder: 'Enter password',
    passwordRequired: 'Please enter password',
    passwordInvalid: 'Password must be at least 6 characters',
    confirmPassword: 'Confirm Password',
    confirmPasswordPlaceholder: 'Please enter password again',
    confirmPasswordRequired: 'Please confirm password',
    passwordMismatch: 'Passwords do not match',
    registerButton: 'Register',
    hasAccount: 'Already have an account?',
    loginNow: 'Login now',
    emailExists: 'This email is already registered',
    usernameExists: 'This username is already taken',
    registerSuccess: 'Registration successful! Please login.',
  },
  companyInfo: {
    companyName: 'Company Name',
    companyNameDesc: 'Please enter your company name',
    companyAddress: 'Company Address',
    companyAddressDesc: 'Please enter your company address',
    companyLogo: 'Company Logo',
    companyLogoDesc: 'Please upload your company logo',
    entityCardBg: 'Entity Card Background',
    entityCardBgDesc: 'Please upload your entity card background',
  },
  employee: {
    employeeName: 'Employee Name',
    employeeNameDesc: 'Please enter employee name',
    addEmployee: 'Add Employee',
    employeeNo: 'Employee Number',
    employeeNoDesc: 'Please enter employee number',
    employeeId: 'Employee ID',
    name: 'Name',
    nameDesc: 'Please enter employee name',
    department: 'Department',
    departmentDesc: 'Please enter employee department',
    position: 'Position',
    positionDesc: 'Please enter employee position',
    mobile: 'Mobile',
    mobileDesc: 'Please enter employee mobile number',
    email: 'Email',
    emailDesc: 'Please enter employee email address',
    status: 'Status',
    statusDesc: 'Please select employee status',
    statusActive: 'Active',
    statusInactive: 'Inactive',
    operation: 'Operation',
    confirmDelete: 'Are you sure you want to delete this employee?',
    userExist: 'User already exists',
    emailExist: 'Email already exists',
    userNotExist: 'User does not exist',
  },
  userManagement: {
    username: 'Username',
    usernameDesc: 'Please enter username',
    nickname: 'Nickname',
    email: 'Email',
    status: 'Status',
    statusActive: 'Active',
    statusInactive: 'Inactive',
    operation: 'Operation',
    changePassword: 'Change Password',
    resetPassword: 'Reset Password',
    newPassword: 'New Password',
    newPasswordDesc: 'Please enter new password',
    confirmPassword: 'Confirm Password',
    confirmPasswordDesc: 'Please enter new password again',
    changePasswordSuccess: 'Password changed successfully',
    changePasswordFailed: 'Password change failed',
    resetPasswordSuccess: 'Password reset successfully',
    resetPasswordFailed: 'Password reset failed',
    passwordLengthError: 'Password length must be between 6 and 20 characters',
    passwordMismatchError: 'The two passwords do not match',
    confirmResetPassword: 'Are you sure you want to reset this user\'s password?',
  },
  customerManagement: {
    pageTitle: 'Customer Management',
    pageDesc: 'Manage your customer contacts',
    name: 'Name',
    namePlaceholder: 'Please enter name',
    company: 'Company',
    companyPlaceholder: 'Please enter company name',
    phone: 'Phone',
    phonePlaceholder: 'Please enter phone number',
    email: 'Email',
    emailPlaceholder: 'Please enter email address',
    department: 'Department',
    departmentPlaceholder: 'Please enter department',
    jobTitle: 'Job Title',
    jobTitlePlaceholder: 'Please enter job title',
    createDate: 'Create Date',
    startDate: 'Start Date',
    endDate: 'End Date',
    to: 'To',
    reset: 'Reset',
    add: 'Add',
    addCustomer: 'Add Customer',
    editCustomer: 'Edit Customer',
    deleteConfirm: 'Are you sure you want to delete this customer?',
    more: 'More',
    firstName: 'First Name',
    lastName: 'Last Name',
    firstNamePlaceholder: 'Enter first name',
    lastNamePlaceholder: 'Enter last name',
    firstNameRequired: 'Please enter first name',
    lastNameRequired: 'Please enter last name',
    firstNameMaxLength: 'First name max 30 characters',
    lastNameMaxLength: 'Last name max 30 characters',
    phoneRequired: 'Please enter phone number',
    phoneFormatError: 'Please enter a valid phone number format',
    companyRequired: 'Please enter company name',
    companyMaxLength: 'Company name max 60 characters',
    emailFormatError: 'Please enter a valid email format',
    departmentMaxLength: 'Department max 60 characters',
    jobTitleMaxLength: 'Job title max 60 characters',
  },
  platformCompany: {
    name: 'Name',
    namePlaceholder: 'Enter enterprise customer name',
    email: 'Email',
    emailPlaceholder: 'Enter email',
    phone: 'Phone',
    phonePlaceholder: 'Enter contact phone',
    createDate: 'Created Time',
    startDate: 'Start date',
    endDate: 'End date',
    to: 'to',
    add: 'Add',
    resetSearch: 'Reset',
    companyName: 'Enterprise Customer Name',
    code: 'Code',
    contactName: 'Contact',
    contactNamePlaceholder: 'Enter contact name',
    operation: 'Operation',
    addCompany: 'Add Enterprise Customer',
    editCompany: 'Edit Enterprise Customer',
    website: 'Website',
    websitePlaceholder: 'Enter enterprise website',
    admins: 'Enterprise Admins',
    adminName: 'Name',
    adminNamePlaceholder: 'Enter name',
    adminEmail: 'Email',
    adminEmailPlaceholder: 'Enter email',
    adminMaxTip: 'Up to 3 admins',
    submit: 'Submit',
    refill: 'Reset',
    deleteConfirm: 'Delete this enterprise customer? Data cannot be recovered after deletion.',
    nameRequired: 'Please enter enterprise customer name',
    nameMaxLength: 'Enterprise customer name max 50 characters',
    contactNameRequired: 'Please enter contact name',
    contactNameMaxLength: 'Contact name max 20 characters',
    phoneRequired: 'Please enter contact phone',
    phoneFormatError: 'Please enter a valid mobile number',
    emailRequired: 'Please enter email',
    emailFormatError: 'Please enter a valid email format',
    websiteMaxLength: 'Website max 100 characters',
    adminNameRequired: 'Please enter admin name',
    adminEmailRequired: 'Please enter admin email',
    adminEmailFormatError: 'Please enter a valid email format',
  },
  errorCodeMap: {
    tokenExpired: 'Your account has expired or logged in elsewhere, please log in again',
    systemException: 'System exception, please contact the administrator',
    systemError: 'System error, please contact administrator',
    networkError: 'Please check network connection',
    '000000': 'Database query failed',
    '000001': 'Database insert failed',
    '000002': 'Database update failed',
    '000003': 'Database delete failed',
    '000004': 'Database query returned empty',
    '000005': 'Batch insert failed',
    '010000': 'Connection failed',
    '010001': 'Send failed',
    '010002': 'Receive failed',
    '010003': 'Send timeout',
    '010004': 'Receive timeout',
    '010005': 'Feign call failed',
    '010006': 'Feign call timeout',
    '010007': 'Service rate limit',
    '010008': 'Unable to get service information from service registry',
    '010009': 'Send message failed',
    '010010': 'Send or receive exception',
    '020000': 'File does not exist',
    '020001': 'Folder does not exist',
    '020002': 'Unable to read file',
    '020003': 'Unable to write file',
    '020004': 'Save file failed',
    '020005': 'File name already exists',
    '020006': 'Folder name already exists',
    '020007': 'Unknown file format',
    '020008': 'File conversion failed',
    '030000': 'Insufficient memory',
    '040000': 'Parameter is empty',
    '040001': 'Invalid parameter',
    '040002': 'Data validation error',
    '040003': 'No parameter to update',
    '040004': 'ID is empty',
    '040005': 'Data conversion exception',
    '050000': 'User already invited',
    '050001': 'User already exists',
    '050002': 'Unauthorized',
    '050003': 'User does not exist',
    '050004': 'Invitation code does not exist',
    '050005': 'Unknown business type',
    '050006': 'Failed to convert WeChat payment XML',
    '050007': 'XML parsing exception',
    '050008': 'WeChat returned error',
    '050009': 'No refund record',
    '050010': 'User not logged in',
    '050011': 'Incorrect verification code',
    '050012': 'Verification code expired or does not exist',
    '050013': 'Account status abnormal',
    '050014': 'Static page error',
    '050015': 'User not approved',
    '050016': 'Authorization information already exists',
    '050017': 'Failed to set product category',
    '050018': 'Failed to set product',
    '050019': 'Failed to set product SPU attributes',
    '050020': 'Failed to set product SKU attributes',
    '050021': 'Failed to set product images',
    '050022': 'Failed to set store product',
    '050023': 'Failed to set specification product',
    '050024': 'Failed to set product package',
    '050025': 'Failed to get product code',
    '050026': 'Product and category already associated',
    '050027': 'User not associated with merchant',
    '050028': 'Login permission expired',
    '050029': 'Failed to update merchant login token',
    '050030': 'Category and printer already associated',
    '050031': 'Payment amount abnormal',
    '050032': 'No consumption record',
    '050033': 'Refund time expired',
    '050034': 'Refund amount abnormal',
    '050035': 'UUID duplicate',
    '050036': 'Data exception',
    '050037': 'Login failed',
    '050038': 'Registration failed',
    '050039': 'Duplicate consumption',
    '050040': 'Account or password error',
    '050041': 'Unknown transaction',
    '050042': 'Insufficient transaction amount',
    '050043': 'Transaction failed',
    '050044': 'Order does not exist or expired',
    '050045': 'Already bound',
    '050046': 'Subordinate exists',
    '050047': 'Name duplicate',
    '050048': 'Upload image failed',
    '050049': 'Already bound to user',
    '050050': 'Merchant configuration information does not exist',
    '050051': 'Failed to get WeChat mini program login state',
    '050052': 'Failed to decrypt data',
    '050053': 'ES query failed',
    '050054': 'ES insert failed',
    '050055': 'ES update failed',
    '050056': 'ES delete failed',
    '050057': 'ES query returned empty',
    '050058': 'ES delete index failed',
    '050059': 'Merchant role is empty',
    '050060': 'Configuration for this feature service does not exist',
    '050061': 'Failed to query organization information',
    '050062': 'Failed to get merchant information',
    '050063': 'Script execution failed',
    '050064': 'Token invalid',
    '050065': 'Number already exists',
    '050066': 'Pending allocation quantity too large',
    '050067': 'Built-in information, cannot delete',
    '050068': 'Failed to configure merchant information',
    '050069': 'This merchant has failed activation records',
    '050070': 'Failed to export file',
    '050071': 'Failed to execute clearing',
    '050072': 'No clearing data',
    '050073': 'Failed to cache data',
    '050074': 'Failed to execute reconciliation',
    '050075': 'Reconciliation amount abnormal',
    '050076': 'Account disabled',
    '050077': 'Merchant not authorized',
    '050078': 'User has no permission',
    '050079': 'Unallocated quantity less than pending allocation quantity',
    '050080': 'Failed to parse device code',
    '050081': 'Failed to parse device code manufacturer',
    '050082': 'Failed to parse device code brand',
    '050083': 'Failed to parse device code type',
    '050084': 'Failed to parse device code batch number',
    '050085': 'Failed to parse device code model',
    '050086': 'Device allocation failed',
    '050087': 'Device code is empty',
    '050088': 'Device code length incorrect',
    '050089': 'Template already in use',
    '050090': 'Person already used by notification group',
    '050091': 'Menu query returned empty',
    '050092': 'Organization already bound to account',
    '050093': 'Account abnormal',
    '050094': 'Original password error',
    '050095': 'Order abnormal, please place order again',
    '050096': 'Payment abnormal',
    '050097': 'Activity information abnormal',
    '050098': 'Failed to get user information',
    '050099': 'Insufficient inventory',
    '050100': 'security_uuid duplicate',
    '050101': 'Transfer to refund',
    '050102': 'Unpaid',
    '050103': 'Closed',
    '050104': 'Revoked',
    '050105': 'User paying',
    '050106': 'Payment failed',
    '050107': 'Data stream close exception',
    '050108': 'Permission already exists',
    '050109': 'Configuration file is empty',
    '050110': 'Time format error',
    '050111': 'Start time invalid',
    '050112': 'End time invalid',
    '050113': 'Activity time conflict',
    '050114': 'Activity name conflict',
    '050115': 'Scene already associated with task',
    '050116': 'Scene already associated with business type',
    '050117': 'Rule group already associated with business type',
    '050118': 'Business type already associated with task',
    '050119': 'Image not compliant',
    '050120': 'Image group mismatch',
    '050121': 'Unable to get application data preparation script information',
    '050123': 'Name already exists',
    '050124': 'System internal error',
    '050125': 'Failed to get card number',
    '050126': 'Failed to get application key',
    '050127': 'Unable to get encryption machine script information',
    '050128': 'Operation error',
    '050129': 'Key dispersion factor length error',
    '050130': 'IP not authorized',
    '050131': 'Failed to get encryption machine information',
    '050132': 'Failed to get RSA key rules',
    '050133': 'Failed to get TK',
    '050134': 'Failed to get system LMK index',
    '050135': 'Failed to get application information',
    '050136': 'Failed to get application key information',
    '050137': 'Failed to get key index information',
    '050138': 'Key index is empty',
    '050139': 'Failed to get issuer certificate',
    '050140': 'Failed to get issuer key information from encryption machine',
    '050141': 'Failed to get symmetric key information',
    '050142': 'Failed to get symmetric AC key information',
    '050143': 'Failed to get key from encryption machine',
    '050144': 'Failed to get key information bound to application',
    '050145': 'Failed to get key rules',
    '050146': 'Failed to get unused IC card asymmetric key',
    '050147': 'Failed to get issuer index',
    '050148': 'Failed to get IC card asymmetric key information from encryption machine',
    '050149': 'Application already bound to key, please unbind before deleting',
    '050150': 'Sub-application keys under application have bound keys, please unbind before deleting',
    '050151': 'Application does not meet binding conditions',
    '050152': 'Key does not meet binding conditions',
    '050153': 'This encryption machine has been bound by set keys and cannot be deleted',
    '050154': 'Encryption machines under manufacturer have encryption machines in use and cannot be deleted',
    '050155': 'Key already bound, please unbind before deleting',
    '050156': 'Sub-keys under key have bound applications, please unbind before deleting',
    '050157': 'This application has already configured key pool',
    '050158': 'Get application configuration closed',
    '050159': 'Application binding type abnormal',
    '050160': 'Failed to update bound key status',
    '050161': 'Key binding type abnormal',
    '050162': 'Application key name already exists',
    '050163': 'Failed to create bound sub-key information',
    '050164': 'Application already bound, please unbind before editing',
    '050165': 'Rule already bound, not allowed to delete',
    '050166': 'Failed to add scheduled task information',
    '050167': 'Failed to delete scheduled task information',
    '050168': 'This application has already configured task information, cannot configure again',
    '050169': 'Not bound to encryption machine',
    '050170': 'Failed to get CA information',
    '990000': 'Unknown error message',
    '060100': 'Business card does not exist',
    '060101': 'Business card does not exist or offline',
    '060102': 'Business card offline or unavailable',
    '060103': 'Business card not published, cannot share',
    '060104': 'No permission to share this business card',
    '060105': 'Failed to generate QR code',
    '060106': 'Already collected this business card',
    '060107': 'Collection failed',
    '060108': 'Collection record not found',
    '060109': 'Failed to cancel collection',
    '060200': 'Email already exists', // 用户名已存在
    '060201': 'Enterprise registration failed',
    '060202': 'User does not exist',
    '060203': 'Enterprise does not exist',
    '060204': 'No permission to view this enterprise information',
    '060205': 'Failed to update enterprise information',
    '060206': 'No permission to operate other enterprises',
    '060207': 'Operating user does not exist',
    '060208': 'No permission to operate',
    '060209': 'Employee number already exists',
    '060210': 'Failed to add employee',
    '060211': 'User not associated with enterprise',
    '060212': 'Only enterprise administrator can perform this operation',
    '060213': 'Employee does not exist',
    '060214': 'This employee does not belong to this enterprise',
    '060215': 'This user is not an enterprise employee',
    '060216': 'No permission to view this enterprise employee list',
    '060217': 'Failed to update employee information',
    '060218': 'Failed to create administrator user',
    '060300': 'Method parameter cannot be empty',
    '060301': 'Unknown API',
    '060400': 'Refresh token invalid or expired',
    '060401': 'Invalid refresh token',
    '060402': 'Refresh token already used or does not exist',
    "060403": "Request body error",
    "060404": "Request path not allowed",
    "060405": "Request method is null",
    "060406": "Authorization header error",
    "060407": "Empty token",
    "060408": "Token invalid",
    "060409": "Token parse error",
    "060411": "Invalid request",
    "060412": "Missing timestamp or sign",
    "060413": "Request expired",
    "060414": "Duplicate request"

  }
}